const vcloak = ({ addUtilities }) => {
  const utilities = {
    '[v-cloak] .v-cloak-block': {
      display: 'block',
    },
    '.v-cloak-block': {
      display: 'none',
    },
    '[v-cloak] .v-cloak-flex': {
      display: 'flex',
    },
    '.v-cloak-flex': {
      display: 'none',
    },
    '[v-cloak] .v-cloak-hidden': {
      display: 'none',
    },
    '[v-cloak] .v-cloak-inline': {
      display: 'inline',
    },
    '.v-cloak-inline': {
      display: 'none',
    },
    '[v-cloak] .v-cloak-inline-block': {
      display: 'inline-block',
    },
    '.v-cloak-inline-block': {
      display: 'none',
    },
    '[v-cloak] .v-cloak-inline-flex': {
      display: 'inline-flex',
    },
    '.v-cloak-inline-flex': {
      display: 'none',
    },
    '[v-cloak] .v-cloak-invisible': {
      visibility: 'hidden',
    },
  };

  addUtilities(utilities);
};

module.exports = vcloak;
